<template>
</template>
<script>
    import order from '@shared/mixins/order';
    export default {
        props: ['order', 'fuelEnv', 'webName'],
        mixins: [order]
    }
</script>